var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.13195 10H0.868056C0.388642 10 0 10.3886 0 10.8681V19.132C0 19.6114 0.388642 20 0.868056 20H4.13195C4.61136 20 5 19.6114 5 19.132V10.8681C5 10.3886 4.61136 10 4.13195 10Z",
    fill: "#777777"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6319 0H8.36806C7.88864 0 7.5 0.388642 7.5 0.868057V19.132C7.5 19.6114 7.88864 20 8.36806 20H11.6319C12.1114 20 12.5 19.6114 12.5 19.132V0.868057C12.5 0.388642 12.1114 0 11.6319 0Z",
    fill: "#777777"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.1319 6.66675H15.8681C15.3886 6.66675 15 7.05539 15 7.5348V19.132C15 19.6115 15.3886 20.0001 15.8681 20.0001H19.1319C19.6114 20.0001 20 19.6115 20 19.132V7.5348C20 7.05539 19.6114 6.66675 19.1319 6.66675Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReports);
export default __webpack_public_path__ + "static/media/reports.a9e688addb8613cf979e559a11cfe3d2.svg";
export { ForwardRef as ReactComponent };